import React from "react";
import classNames from "classnames";
import { TabProps } from "./PropsType";

export default function Tab(props: TabProps) {
  const {
    children,
    className,
    disabled,
    activeIndex,
    index,
    prefixCls = "bm-Tab",
  } = props;

  const handleChange = () => {
    if (!props.disabled && props.onChange) {
      props.onChange(props.index!);
    }
  };
  const styleClass = classNames(
    prefixCls,
    {
      [`${prefixCls}-active`]: activeIndex === index,
      [`${prefixCls}-disabled`]: disabled,
    },
    className
  );
  return (
    <div className={styleClass} onClick={handleChange}>
      <span className={`${prefixCls}-inner`}>{children}</span>
    </div>
  );
}
